import React from "react";
import { fontSizes } from "@/constants/constants";
import { ButtonCta, LiveChatButton } from "../ui";

function ReachCTA({
  text1,
  span,
  h1lovertext,
  classStyle,
  outlined = true,
  btnText1 = "Live Chat",
  btnText2 = "Get a Quote",
}) {
  return (
    <div className="px-4 py-10">
      <div className={`relative mx-auto max-w-[1350px] overflow-hidden rounded-[32px] bg-gradient-to-br from-ink via-brand-900 to-ink px-6 py-16 md:px-16 md:py-20 ${classStyle || ""}`}>
        {/* decorative field */}
        <div aria-hidden className="pointer-events-none absolute -left-20 -top-16 h-72 w-72 rounded-full bg-brand-500/25 blur-3xl" />
        <div aria-hidden className="pointer-events-none absolute -right-16 -bottom-16 h-72 w-72 rounded-full bg-gold/15 blur-3xl" />
        {/* big watermark word */}
        {outlined && text1 && (
          <h2
            aria-hidden
            className={`pointer-events-none absolute inset-x-0 top-2 select-none text-center font-display font-semibold uppercase leading-none text-white/[0.05] ${fontSizes.text_9_xl}`}
          >
            {text1}
          </h2>
        )}

        <div className="relative mx-auto flex max-w-3xl flex-col items-center text-center">
          <span className="eyebrow flex items-center gap-3 text-gold-soft">
            <span className="h-px w-8 bg-gold/70" />
            Let&apos;s Begin
            <span className="h-px w-8 bg-gold/70" />
          </span>

          <h3 className={`mt-5 font-display font-semibold capitalize leading-[1.1] text-white ${fontSizes.text_6_xl}`}>
            {h1lovertext}
          </h3>

          <p className={`mt-5 leading-relaxed text-white/75 ${fontSizes.base}`}>
            {span}
          </p>

          <div className="mt-9 flex flex-wrap items-center justify-center gap-4">
            <ButtonCta buttonText={btnText2} classStyle={`text-ink bg-gold hover:bg-gold-soft h-12`} />
            <LiveChatButton buttonText={btnText1} classStyle={`text-white bg-white/10 border border-white/30 backdrop-blur hover:bg-white/20 h-12`} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReachCTA;
